import moment from 'moment';
import React from 'react';
import {
  CheckIcon,
  ReceiptRefundIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';
import { ClockIcon } from '@heroicons/react/20/solid';
import { TWButton } from '../../../components/ui';

const STATUS_META = [
  {
    id: 1,
    name: 'Succeeded',
    status: 'succeeded',
    icon: <CheckIcon className="h-5 w-5 text-white" aria-hidden />,
    iconBackground: 'bg-emerald-500',
  },
  {
    id: 2,
    name: 'Requires Capture',
    status: 'requires_capture',
    icon: <ClockIcon className="h-5 w-5 text-white" aria-hidden />,
    iconBackground: 'bg-amber-500',
  },
  {
    id: 3,
    name: 'Refund',
    status: 'Refund',
    icon: <ReceiptRefundIcon className="h-5 w-5 text-white" aria-hidden />,
    iconBackground: 'bg-rose-500',
  },
];

const formatCents = (number) => {
  const formatted = ((number || 0) / 100).toFixed(2);
  return `$${formatted}`;
};

const PaymentLogs = ({ payments, onClickOpenStripeNewTab }) => (
  <div className="flow-root">
    <div className="py-5">
      <TWButton
        icon={LinkIcon}
        label="Stripe Link"
        onClick={() => onClickOpenStripeNewTab()}
      />
    </div>
    <ul className="-mb-8">
      {payments &&
        payments
          .sort((a, b) => moment(a.createdate).diff(moment(b.createdate)))
          ?.map((payment, i) => {
            const stripePaymentStatus = STATUS_META.find(
              (x) => x.status === payment.status,
            );

            return (
              <li key={i}>
                <div className="relative pb-8">
                  {i !== payments?.length - 1 ? (
                    <span
                      className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-slate-200 dark:bg-slate-700"
                      aria-hidden
                    />
                  ) : null}
                  <div className="relative flex space-x-3">
                    <div>
                      <span
                        className={`flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white dark:ring-slate-800 ${stripePaymentStatus?.iconBackground || 'bg-slate-400'}`}
                      >
                        {stripePaymentStatus?.icon}
                      </span>
                    </div>
                    <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                      <div className="flex-auto rounded-md p-3 ring-1 ring-inset ring-slate-200 dark:ring-slate-600">
                        <div className="flex flex-col justify-between gap-x-4 sm:flex-row">
                          <div className="py-0.5 text-xs leading-5 text-slate-500 dark:text-slate-400">
                            <h1 className="text-lg font-medium text-slate-900 dark:text-slate-100">
                              Status: {stripePaymentStatus?.name}
                            </h1>
                            <br />
                            <p className="text-sm leading-6 text-slate-500 dark:text-slate-400">
                              Payment Id: {payment.id}
                              <br />
                              Amount Received: {formatCents(payment.amountreceived)}
                              <br />
                            </p>
                          </div>
                          <time
                            dateTime="2023-01-23T11:24"
                            className="flex-none py-0.5 text-right text-xs leading-5 text-slate-500 dark:text-slate-400"
                          >
                            {moment
                              .utc(payment.createdate)
                              .local()
                              .format('MM/DD/YYYY hh:mm A')}
                          </time>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
    </ul>
  </div>
);

export default PaymentLogs;
